import { Box, BoxProps, useBoolean } from '@chakra-ui/react';
import NextImage from 'next/image';
import { type CSSProperties } from 'react';

import { Replace } from '$utils/replace';

interface ImageProps
  extends Replace<Omit<BoxProps, 'fill'>, { objectFit?: string }> {
  src: string;
  alt: string;
  quality?: number;
  priority?: boolean;
}

export function Image({
  src,
  alt,
  quality,
  objectFit,
  priority,
  ...props
}: ImageProps) {
  const [loading, controls] = useBoolean(true);

  const style = {
    objectFit,
    overflow: props.overflow,
    border: 'none',
  } as CSSProperties;

  return (
    <Box
      pos="relative"
      bg={loading ? 'bg.elevated' : 'transparent'}
      transition="background 0.4s ease"
      {...props}
    >
      <NextImage
        src={src}
        alt={alt}
        quality={quality}
        priority={priority}
        fill
        style={style}
        onLoadingComplete={controls.off}
      />
    </Box>
  );
}
